module.exports = __webpack_public_path__ + "static/media/lateral-homemodal.93454277.png";